module.exports = __webpack_public_path__ + "img/theme-switch.2b578f32.svg";